export default __webpack_public_path__ + "static/media/540.47803d8b.jpg";